import React from 'react';
import MuiLink from '@mui/material/Link';
import { GatsbyLink } from './glink';
export const Link = React.forwardRef((props, ref) => {
    const { to } = props;
    return to ? (React.createElement(MuiLink, { ref: ref, component: GatsbyLink, to: to, ...props })) : (React.createElement(MuiLink, { ref: ref, ...props }));
});
